module.exports = __webpack_public_path__ + "img/m-icon-s-ocean.c586a604.png";